import { jsxs, jsx } from "react/jsx-runtime";
import classnames from "../../utils/classnames.js";
import Badge from "../Badge/Badge.js";
import Col from "../Grid/Col.js";
import "react";
import Row from "../Grid/Row.js";
import './Header.css';import '../Grid/Grid.css';/* empty css                */
import Typography from "../Typography/Typography.js";
/* empty css            */
const HeaderHeading = ({ title, description, badge, className, ...props }) => {
  return /* @__PURE__ */ jsxs(Row, { className: classnames("perxis-auto-header-heading", className), ...props, children: [
    !!title && /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(Row, { justify: "center", children: /* @__PURE__ */ jsx(Col, { flex: "0 0 auto", children: /* @__PURE__ */ jsxs(Row, { wrap: false, align: "middle", gutter: { xs: 8, sm: 8, md: 8, lg: 16 }, children: [
      /* @__PURE__ */ jsx(Col, { flex: "auto", children: /* @__PURE__ */ jsx(
        Typography.Title,
        {
          headingLevel: 3,
          level: "h1",
          color: "darkest",
          className: classnames("perxis-auto-header-heading__title"),
          children: title
        }
      ) }),
      !!(badge == null ? void 0 : badge.count) && /* @__PURE__ */ jsx(Col, { flex: "none", children: /* @__PURE__ */ jsx(Badge, { type: badge.type, count: badge.count, className: classnames("perxis-auto-header-heading__badge") }) })
    ] }) }) }) }),
    !!description && /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(Row, { justify: "center", children: /* @__PURE__ */ jsx(Col, { flex: "0 0 auto", children: /* @__PURE__ */ jsx(
      Typography.Title,
      {
        color: "dark-light",
        headingLevel: 4,
        level: "h4",
        className: classnames("perxis-auto-header-heading__description"),
        children: description
      }
    ) }) }) })
  ] });
};
export {
  HeaderHeading as default
};
//# sourceMappingURL=HeaderHeading.js.map
